import BasicInformationSection from './BasicInformationSection';

export default BasicInformationSection;
